import { Country } from '@/api/useCountryApi'

export const shippableCountries: Country[] = [
  {
    code: 'AD',
    countryCode: 'AD',
    name: 'Andorra',
  },
  {
    code: 'AI',
    countryCode: 'AI',
    name: 'Anguilla',
  },
  {
    code: 'AG',
    countryCode: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    code: 'AW',
    countryCode: 'AW',
    name: 'Aruba',
  },
  {
    code: 'AU',
    countryCode: 'AU',
    name: 'Australia',
  },
  {
    code: 'AT',
    countryCode: 'AT',
    name: 'Austria',
  },
  {
    code: 'BS',
    countryCode: 'BS',
    name: 'Bahamas',
  },
  {
    code: 'BH',
    countryCode: 'BH',
    name: 'Bahrain',
  },
  {
    code: 'BD',
    countryCode: 'BD',
    name: 'Bangladesh',
  },
  {
    code: 'BB',
    countryCode: 'BB',
    name: 'Barbados',
  },
  {
    code: 'BY',
    countryCode: 'BY',
    name: 'Belarus',
  },
  {
    code: 'BE',
    countryCode: 'BE',
    name: 'Belgium',
  },
  {
    code: 'BM',
    countryCode: 'BM',
    name: 'Bermuda',
  },
  {
    code: 'BT',
    countryCode: 'BT',
    name: 'Bhutan',
  },
  {
    code: 'XB',
    countryCode: 'XB',
    name: 'Bonaire',
  },
  {
    code: 'BA',
    countryCode: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    code: 'BN',
    countryCode: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    code: 'BG',
    countryCode: 'BG',
    name: 'Bulgaria',
  },
  {
    code: 'KH',
    countryCode: 'KH',
    name: 'Cambodia',
  },
  {
    code: 'CA',
    countryCode: 'CA',
    name: 'Canada',
  },
  {
    code: 'IC',
    countryCode: 'IC',
    name: 'Canary Islands',
  },
  {
    code: 'KY',
    countryCode: 'KY',
    name: 'Cayman Islands',
  },
  {
    code: 'HR',
    countryCode: 'HR',
    name: 'Croatia',
  },
  {
    code: 'XC',
    countryCode: 'XC',
    name: 'Curacao',
  },
  {
    code: 'CY',
    countryCode: 'CY',
    name: 'Cyprus',
  },
  {
    code: 'CZ',
    countryCode: 'CZ',
    name: 'Czech Republic',
  },
  {
    code: 'DK',
    countryCode: 'DK',
    name: 'Denmark',
  },
  {
    code: 'DO',
    countryCode: 'DO',
    name: 'Dominican Republic',
  },
  {
    code: 'EC',
    countryCode: 'EC',
    name: 'Ecuador',
  },
  {
    code: 'EG',
    countryCode: 'EG',
    name: 'Egypt',
  },
  {
    code: 'EE',
    countryCode: 'EE',
    name: 'Estonia',
  },
  {
    code: 'FJ',
    countryCode: 'FJ',
    name: 'Fiji',
  },
  {
    code: 'FI',
    countryCode: 'FI',
    name: 'Finland',
  },
  {
    code: 'FR',
    countryCode: 'FR',
    name: 'France',
  },
  {
    code: 'PF',
    countryCode: 'PF',
    name: 'French Polynesia',
  },
  {
    code: 'DE',
    countryCode: 'DE',
    name: 'Germany',
  },
  {
    code: 'GI',
    countryCode: 'GI',
    name: 'Gibraltar',
  },
  {
    code: 'GR',
    countryCode: 'GR',
    name: 'Greece',
  },
  {
    code: 'GD',
    countryCode: 'GD',
    name: 'Grenada',
  },
  {
    code: 'GP',
    countryCode: 'GP',
    name: 'Guadeloupe',
  },
  {
    code: 'HK',
    countryCode: 'HK',
    name: 'Hong Kong',
  },
  {
    code: 'HU',
    countryCode: 'HU',
    name: 'Hungary',
  },
  {
    code: 'IS',
    countryCode: 'IS',
    name: 'Iceland',
  },
  {
    code: 'IE',
    countryCode: 'IE',
    name: 'Ireland',
  },
  {
    code: 'IT',
    countryCode: 'IT',
    name: 'Italy',
  },
  {
    code: 'JM',
    countryCode: 'JM',
    name: 'Jamaica',
  },
  {
    code: 'JP',
    countryCode: 'JP',
    name: 'Japan',
  },
  {
    code: 'JE',
    countryCode: 'JE',
    name: 'Jersey',
  },
  {
    code: 'KR',
    countryCode: 'KR',
    name: 'Korea, Republic of',
  },
  {
    code: 'KV',
    countryCode: 'KV',
    name: 'Kosovo',
  },
  {
    code: 'KW',
    countryCode: 'KW',
    name: 'Kuwait',
  },
  {
    code: 'LA',
    countryCode: 'LA',
    name: "Lao People's Democratic Republic",
  },
  {
    code: 'LV',
    countryCode: 'LV',
    name: 'Latvia',
  },
  {
    code: 'LI',
    countryCode: 'LI',
    name: 'Liechtenstein',
  },
  {
    code: 'LT',
    countryCode: 'LT',
    name: 'Lithuania',
  },
  {
    code: 'LU',
    countryCode: 'LU',
    name: 'Luxembourg',
  },
  {
    code: 'MO',
    countryCode: 'MO',
    name: 'Macao',
  },
  {
    code: 'MK',
    countryCode: 'MK',
    name: 'Macedonia, Republic of',
  },
  {
    code: 'MW',
    countryCode: 'MW',
    name: 'Malawi',
  },
  {
    code: 'MY',
    countryCode: 'MY',
    name: 'Malaysia',
  },
  {
    code: 'MV',
    countryCode: 'MV',
    name: 'Maldives',
  },
  {
    code: 'MT',
    countryCode: 'MT',
    name: 'Malta',
  },
  {
    code: 'MQ',
    countryCode: 'MQ',
    name: 'Martinique',
  },
  {
    code: 'MD',
    countryCode: 'MD',
    name: 'Moldova, Republic of',
  },
  {
    code: 'MC',
    countryCode: 'MC',
    name: 'Monaco',
  },
  {
    code: 'ME',
    countryCode: 'ME',
    name: 'Montenegro',
  },
  {
    code: 'MA',
    countryCode: 'MA',
    name: 'Morocco',
  },
  {
    code: 'MM',
    countryCode: 'MM',
    name: 'Myanmar',
  },
  {
    code: 'NL',
    countryCode: 'NL',
    name: 'Netherlands',
  },
  {
    code: 'XN',
    countryCode: 'XN',
    name: 'Nevis',
  },
  {
    code: 'NZ',
    countryCode: 'NZ',
    name: 'New Zealand',
  },
  {
    code: 'NO',
    countryCode: 'NO',
    name: 'Norway',
  },
  {
    code: 'OM',
    countryCode: 'OM',
    name: 'Oman',
  },
  {
    code: 'PH',
    countryCode: 'PH',
    name: 'Philippines',
  },
  {
    code: 'PL',
    countryCode: 'PL',
    name: 'Poland',
  },
  {
    code: 'PT',
    countryCode: 'PT',
    name: 'Portugal',
  },
  {
    code: 'PR',
    countryCode: 'PR',
    name: 'Puerto Rico',
  },
  {
    code: 'QA',
    countryCode: 'QA',
    name: 'Qatar',
  },
  {
    code: 'RO',
    countryCode: 'RO',
    name: 'Romania',
  },
  {
    code: 'BL',
    countryCode: 'BL',
    name: 'Saint Barthélemy',
  },
  {
    code: 'KN',
    countryCode: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    code: 'LC',
    countryCode: 'LC',
    name: 'Saint Lucia',
  },
  {
    code: 'VC',
    countryCode: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'SM',
    countryCode: 'SM',
    name: 'San Marino',
  },
  {
    code: 'SA',
    countryCode: 'SA',
    name: 'Saudi Arabia',
  },
  {
    code: 'RS',
    countryCode: 'RS',
    name: 'Serbia',
  },
  {
    code: 'SC',
    countryCode: 'SC',
    name: 'Seychelles',
  },
  {
    code: 'SG',
    countryCode: 'SG',
    name: 'Singapore',
  },
  {
    code: 'SX',
    countryCode: 'SX',
    name: 'Sint Maarten (Dutch part)',
  },
  {
    code: 'SK',
    countryCode: 'SK',
    name: 'Slovakia',
  },
  {
    code: 'SI',
    countryCode: 'SI',
    name: 'Slovenia',
  },
  {
    code: 'ZA',
    countryCode: 'ZA',
    name: 'South Africa',
  },
  {
    code: 'ES',
    countryCode: 'ES',
    name: 'Spain',
  },
  {
    code: 'LK',
    countryCode: 'LK',
    name: 'Sri Lanka',
  },
  {
    code: 'XY',
    countryCode: 'XY',
    name: 'St. Barthelemy',
  },
  {
    code: 'XM',
    countryCode: 'XM',
    name: 'St. Maarten',
  },
  {
    code: 'SE',
    countryCode: 'SE',
    name: 'Sweden',
  },
  {
    code: 'CH',
    countryCode: 'CH',
    name: 'Switzerland',
  },
  {
    code: 'TW',
    countryCode: 'TW',
    name: 'Taiwan, Province of China',
  },
  {
    code: 'TH',
    countryCode: 'TH',
    name: 'Thailand',
  },
  {
    code: 'TT',
    countryCode: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    code: 'TR',
    countryCode: 'TR',
    name: 'Turkey',
  },
  {
    code: 'TC',
    countryCode: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    code: 'AE',
    countryCode: 'AE',
    name: 'United Arab Emirates',
  },
  {
    code: 'GB',
    countryCode: 'GB',
    name: 'United Kingdom',
  },
  {
    code: 'US',
    countryCode: 'US',
    name: 'United States',
  },
  {
    code: 'VG',
    countryCode: 'VG',
    name: 'Virgin Islands, British',
  },
  {
    code: 'VI',
    countryCode: 'VI',
    name: 'Virgin Islands, U.S.',
  },
  {
    code: 'YE',
    countryCode: 'YE',
    name: 'Yemen',
  },
]
